import ApiService from './api'
import { panaceiaCaseRequest } from './panaceiaRequests'

const base = 'modelos-pecas/rag/pesquisas'
const path = (id) => `${base}/${encodeURIComponent(id)}`
const post = (body, signal) => ({ method: 'POST', body: JSON.stringify(body), signal, timeoutMs: 120000 })

const LegalResearch = {
  start: (fields, signal) => ApiService.request(base, post({ input: panaceiaCaseRequest(fields), analyze: true }, signal)),
  get: (id, signal) => ApiService.request(path(id), { signal }),
  cancel: (id, signal) => ApiService.request(`${path(id)}/cancelar`, post({}, signal)),
  retry: (id, revision, signal) => ApiService.request(`${path(id)}/retomar`, post({ revision }, signal)),
  review: (id, revision, validationId, review, signal) => ApiService.request(`${path(id)}/revisao`,
    post({ revision, validationId, review }, signal)),
  feedback: (id, body, signal) => ApiService.request(`${path(id)}/pertinencia`, post(body, signal)),
  publicReuse: (id, body, signal) => ApiService.request(`${path(id)}/reuso-publico`, post(body, signal)),
  attach: (id, revision, candidateId, document, signal) => ApiService.request(`${path(id)}/documentos`,
    post({ revision, candidateId, document }, signal)),
  importCandidate: (id, revision, document, issueIds, signal) => ApiService.request(`${path(id)}/documentos/importacao-assistida`,
    post({ revision, document, issueIds }, signal)),
  readSource: (id, revision, officialUrl, issueIds, signal) => ApiService.request(`${path(id)}/documentos/ler-fonte`,
    post({ revision, officialUrl, issueIds }, signal)),
  text: (id, versionId, signal) => ApiService.request(`${path(id)}/documentos/${encodeURIComponent(versionId)}/texto`, { signal }),
  original: (id, versionId, signal) => ApiService.request(`${path(id)}/documentos/${encodeURIComponent(versionId)}/original`,
    { signal, responseType: 'blob', timeoutMs: 60000 }),
}

export default LegalResearch
